import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'Home',
			component: (resolve) => require(['@/views/Home.vue'], resolve),
		},
		{
			path: '/Server',
			name: 'Server',
			component: (resolve) => require(['@/views/Server.vue'], resolve),
		},

		{
			path: '/AboutUs',
			name: 'AboutUs',
			component: (resolve) => require(['@/views/AboutUs.vue'], resolve),
		},
		{
			path: '/ContactUs',
			name: 'ContactUs',
			component: (resolve) => require(['@/views/ContactUs.vue'], resolve),
		},
	],
})
